import { Error } from "@mui/icons-material";
import { confirmationDialog } from "src/framework/store/ConfirmationDialogStore";

export function showBlockInvertersAlert (onConfirmation?: Function, onClose?: Function) {
  confirmationDialog.setup({
    onlyConfirm: true,
    content: ['As linhas de inversores IONS e EGT não são compatíveis devido às variações nas plataformas de monitoramento. Por favor, selecione apenas uma das famílias de inversores para o dimensionamento do gerador solar Intelbras.'],
    size: '440px',
    title: "Atenção!",
    yesText: 'OK',
    propagateWhenConfirm: true,
    onClose: () => {
      confirmationDialog.close();
      if (onClose) onClose();
    },
    onConfirmation: () => {
      if(onConfirmation) onConfirmation();
    },
    headerIcon: <Error style={{ color: '#CC8F00' }} />, 
  })
  confirmationDialog.open();

}